import type { ReactNode } from "react";

/**
 * Every screen before the shell (sign in, the refusal, the API being down, a
 * misconfigured build) as one sheet on one backdrop, the way a Mac app greets
 * you before its window: the app's icon, a bold line saying where you are,
 * a sentence on what to do, and the buttons for doing it.
 *
 * They share the backdrop with the boot spinner (`.centered` in App.tsx), so
 * the console arrives on the colour it will greet you with rather than
 * flashing grey first.
 */
export function FrontDoor({
  title,
  children,
  actions,
}: {
  title: string;
  /** The sentence under the title. */
  children: ReactNode;
  /** The buttons, default last: it sits on the right, as a Mac sheet puts it. */
  actions?: ReactNode;
}) {
  return (
    <div className="centered">
      <div className="card">
        <img className="card-icon" src={`${import.meta.env.BASE_URL}nerona-icon.svg`} alt="" />
        <div className="stack card-copy">
          <h1>{title}</h1>
          {children}
        </div>
        {actions ? <div className="card-actions">{actions}</div> : null}
      </div>
    </div>
  );
}
